import HeaderList from "../../components/HeaderList"
import { PageProps } from '../../components/types'
import DataGrid, { FormatterProps } from 'react-data-grid'
import { 
  PicklistStatus
} from '../../constants/EnumType'
import { 
  getColunmPicklist,
  PicklistQaCheckOrderColumn
} from '../../constants/Column'
import { 
  useCallback,
  useMemo,
  useState 
} from "react";

import useQaCheckOrderPicklist from "../../hooks/useQaCheckOrderPicklist"

import { 
  DgtPdOrderPicklist
} from "../../models"

import RowClickable from '../../components/RowClickable'
import { HiDocumentText } from 'react-icons/hi'

const PicklistQaCheck = ({ title, division, line, from, to, username, readOnly }: PageProps) => {
  const [statuses, setStatuses] = useState<string[]>([ PicklistStatus.PD_CHECKED ])
  const [dateRange, setDateRange] = useState<[Date, Date]>([from || new Date(), to || new Date()]);
  const [keyword, setKeyword] = useState<string>('')
  const [div, setDiv] = useState<string>(division!)

  const filterChanged = useCallback((
    key: string, value: string, dateRange?: [Date, Date], values?: string[]) => {
    switch(key) {
      case 'Status':
        return setStatuses(values!)
      case 'Released Date Range':
        return setDateRange(dateRange!)
      case 'Search':
        return setKeyword(value)
      case 'Division':
        return setDiv(value)
      default:
        break
    }
  }, [])

  const coupleStatuses = useMemo(() => 
    [PicklistStatus.PD_CHECKED, PicklistStatus.QA_CHECKED]
  , [])

  const picklists = useQaCheckOrderPicklist(statuses[0], dateRange[0], dateRange[1], keyword, div)

  let orderColumns = getColunmPicklist(PicklistQaCheckOrderColumn, {
    key: 'action', name: '',  width: 50, formatter: (props: FormatterProps<DgtPdOrderPicklist>) => {
      return <div className='flex items-center justify-center gap-1 text-blue-500'>
        <HiDocumentText /><RowClickable value={`${props.row.pk}${props.row.extraReturnId ? '/extra/'+props.row.extraReturnId:''}`} label='ดูใบเบิก'/>
      </div> }
  })

  return <div className="page-container">
    <HeaderList title={title} subTitle={`แผนก : ${division}`}
      orderType='Mixing'
      statuses={statuses}
      dateRange={dateRange}
      keywordSearch={keyword}
      coupleStatuses={coupleStatuses}
      filterChanged={filterChanged}
      filterType={false}
      division={div}
    />
    <DataGrid
      className="mt-4"
      style={{ height: "100%", contain: "none" }}
      columns={orderColumns}
      rows={picklists}
      defaultColumnOptions={{ resizable: true }}
      rowHeight={56}
    />
  </div>
}

export default PicklistQaCheck